/**
 * Pushes phone and WhatsApp link clicks to GTM dataLayer.
 * Configure GTM triggers on the `phone_click` and `whatsapp_click` events.
 */
(function () {
  'use strict';

  /**
   * @param {HTMLAnchorElement} link
   * @returns {string}
   */
  function getClickLocation(link) {
    if (link.classList.contains('whatsapp-sticky-widget')) return 'sticky_widget';
    if (link.closest('.header-cta-bar')) return 'header_cta_bar';
    if (link.closest('.header-cta-buttons') || link.classList.contains('header-cta--whatsapp')) {
      return 'header';
    }
    if (link.classList.contains('header-cta--phone') || link.closest('.header-cta-phone-desktop')) {
      return 'header';
    }
    if (link.closest('.video-with-text__phone-cta') || link.classList.contains('video-with-text__phone')) {
      return 'callback_card';
    }
    if (link.closest('footer')) return 'footer';
    return 'other';
  }

  /**
   * @param {HTMLAnchorElement} link
   * @returns {string}
   */
  function getLinkLabel(link) {
    return (link.getAttribute('aria-label') || link.textContent || '').trim().replace(/\s+/g, ' ');
  }

  /**
   * @param {'phone' | 'whatsapp'} method
   * @param {HTMLAnchorElement} link
   */
  function pushContactEvent(method, link) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: method === 'phone' ? 'phone_click' : 'whatsapp_click',
      contact_method: method,
      link_url: link.href,
      link_text: getLinkLabel(link),
      click_location: getClickLocation(link),
      page_path: window.location.pathname,
      page_title: document.title,
    });
  }

  /**
   * @param {MouseEvent} event
   */
  function handleClick(event) {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a[href]');
    if (!(link instanceof HTMLAnchorElement)) return;

    const href = link.getAttribute('href') || '';
    const hrefLower = href.toLowerCase();

    if (hrefLower.startsWith('tel:')) {
      pushContactEvent('phone', link);
      return;
    }

    if (hrefLower.includes('whatsapp') || hrefLower.includes('wa.me')) {
      pushContactEvent('whatsapp', link);
    }
  }

  document.addEventListener('click', handleClick, { capture: true });
})();
